import React from "react";
import { Dialog, DialogContent, DialogActions, Box } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import { Button } from "@packages/ui";
import { useDispatch } from "react-redux";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import * as rentalActions from "src/actions/rentalActions";
import * as appActions from "src/actions/appActions";
import { useNavigate } from "react-router-dom";
const RentalInsuranceDialog = ({ open, onClose, setCustomerPay }) => {
  const [insurerPaying, setInsurerPaying] = React.useState(false);
  const dispatch = useDispatch();
  const brand = getBrandFromUrl();
  const navigate = useNavigate();

  const logout = () => {
    dispatch(rentalActions.logout());
    dispatch(
      appActions.createToast({
        type: "success",
        message: "Logout success",
      })
    );
    navigate(`/rental/manage/login?brand=${brand}`);
  };
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      {!insurerPaying ? (
        <>
          <DialogContent>
            <Box display="flex" alignItems="center">
              <WarningIcon style={{ color: "#ffa726", fontSize: 48, marginRight: 16 }} />
              <Box>
                <p style={{ margin: "8px 0 0 0", fontSize: "18px", fontWeight: 700 }}>
                  Please confirm whether you or your insurer will be responsible for covering the
                  rental charges for the additional days requested?
                </p>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Box display="flex" justifyContent="space-between" width="100%">
              <Button
                color="primary"
                onClick={() => {
                  setCustomerPay(true);
                  onClose();
                }}
                variant="outlined"
              >
                I am paying
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  setInsurerPaying(true);
                  setCustomerPay(false);
                }}
              >
                My insurer is paying
              </Button>
            </Box>
          </DialogActions>
        </>
      ) : (
        <DialogContent>
          <Box
            sx={{
              borderRadius: "4px",
              padding: 2,
              marginBottom: 2,
              width: "100%",
              textAlign: "left",
            }}
          >
            <span style={{ fontSize: "18px", fontWeight: 700 }}>
              Please contact your insurer to discuss your options for a rental extension.
            </span>
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "flex-end", marginTop: "15px" }}
            >
              <Button color="secondary" variant="contained" onClick={logout}>
                Logout
              </Button>
            </Box>
          </Box>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default RentalInsuranceDialog;
